import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Een token dat er wel is maar verlopen, telt niet: anders opent de pagina
  // gewoon, krijgt elk verzoek een 401 en blijft alles leeg (02-09-2026).
  const isLoggedIn = authService.token && !authService.tokenVerlopen();
  if (!isLoggedIn) {
    if (authService.token) {
      authService.logout();
    }
    // Preserve where the user was heading (e.g. the /claim deep-link a phone
    // opened from a recorder QR) so login returns there, not the dashboard.
    void router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }
  return true;
}
